<template>
  <div class="rating-icon" :class="classNames" @click="click">
    {{ rating.text }}
  </div>
</template>

<script>
import { climatePledgeInfoboxRatingClick } from '~~/search/common/js/client/analytics/climate-pledge-ratings';

export default {
  name: 'EClimateRating',
  props: {
    rating: {
      type: Object,
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    onClick: {
      type: Function,
      required: true,
    },
  },
  computed: {
    classNames() {
      let className = '';
      if (this.isActive) {
        className = `active color-${this.rating.text.toLowerCase()}`;
      }
      return className;
    },
  },
  methods: {
    click() {
      if (this.isActive) {
        this.onClick();
        this.$track(climatePledgeInfoboxRatingClick);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.rating-icon {
  border: $border-width solid var(--color-decorative-border-1);
  display: block;
  border-radius: 50%;
  width: $space-2l;
  height: $space-2l;
  line-height: $space-2l - $space-2s;
  text-align: center;
  margin-right: $space-2s;
  color: var(--color-text-secondary);
}

.rating-icon.active {
  color: $black;
  cursor: pointer;
}

.rating-icon.active.color-a {
  background-color: $c-green-30;
  border: $border-width solid $c-green-30;

  &:hover {
    background-color: rgba($c-green-30, $opacity-1l);
  }
}

.rating-icon.active.color-b {
  background-color: $c-green-40;
  border: $border-width solid $c-green-40;

  &:hover {
    background-color: rgba($c-green-40, $opacity-1l);
  }
}

.rating-icon.active.color-c {
  background-color: $c-yellow-40;
  border: $border-width solid $c-yellow-40;

  &:hover {
    background-color: rgba($c-yellow-40, $opacity-1l);
  }
}

.rating-icon.active.color-d {
  background-color: $c-red-30;
  border: $border-width solid $c-red-30;

  &:hover {
    background-color: rgba($c-red-30, $opacity-1l);
  }
}

.rating-icon.active.color-f {
  background-color: $c-red-40;
  border: $border-width solid $c-red-40;

  &:hover {
    background-color: rgba($c-red-40, $opacity-1l);
  }
}
</style>
